import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import './ProjectsDetails.css';

const ProjectsDetails = () => {
    const { title } = useParams();
    const [projects, setProjects] = useState([]);
    const [project, setProject] = useState([]);
    const url = `/syedhasib.json`;
    useEffect(() => {
        fetch(url)
            .then(res => res.json())
            .then(data => setProjects(data));

    }, [url]);
    useEffect(() => {
        const filterdProject = projects.filter(project => {
            return project.name === title;
        });
        setProject(...filterdProject);
    }, [projects, title])

    console.log(project?.images);
    return (
        <div className="BodySecondary">
            <div className="photo-gallery">
                <div className="container">
                    <div className="intro">
                        <h2 className="text-center text-success">Thanks for visiting this page</h2>
                    </div>
                    <div className="row photos d-flex align-items-center">
                        <div className="col-md-7">
                            <div className="row">
                                <div className="col-sm-6 col-md-4 col-lg-4 item"><a href={ project?.img } data-lightbox="photos"><img alt="img" className="img-fluid" src={ project?.img } /></a></div>
                                <div className="col-sm-6 col-md-4 col-lg-4 item"><a href={ project?.img } data-lightbox="photos"><img alt="img" className="img-fluid" src={ project?.img } /></a></div>
                                <div className="col-sm-6 col-md-4 col-lg-4 item"><a href={ project?.img } data-lightbox="photos"><img alt="img" className="img-fluid" src={ project?.img } /></a></div>
                                <p className="text-center">{ project?.info }</p>
                                <div className="row">
                                    <div className="cols-12 col-md-3">
                                        <a target="_blank" rel="noreferrer" href={ project?.url } className="btn btn-default filter-button">Live Link</a>
                                    </div>
                                    <div className="cols-12 col-md-5">
                                        <a target="_blank" rel="noreferrer" href={ project?.clientsitecode } className="btn btn-default filter-button">Client Site Source Code</a>
                                    </div>
                                    <div className="cols-12 col-md-4">
                                        <a target="_blank" rel="noreferrer" href={ project?.serversitecode } className="btn btn-default filter-button">Server Site Source Code</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-5">
                            <h2 className="text-center text-info">{ project?.name }</h2>
                            <ul className="text-secondary">
                                <li>{ project?.li1 }</li>
                                <li> { project?.li2 }</li>
                                <li> { project?.li3 }</li>
                                <li> { project?.li4 }</li>
                                <li>
                                    Tools:
                                    <ul>
                                        <li> HTML5, CSS3 , Bootstrap </li>
                                        <li>Firebase Authentication, JWT Token </li>
                                        <li> Stripe Payment Method </li>
                                        <li> React Router Dom </li>
                                        <li>Shipping and Billing System</li>
                                        <li>API, Mongo DB, Heroku and more.</li>
                                        <li>React JS, Node JS, Express JS, React Router, Email JS </li>
                                        <li>Bootstrap for Front-End and  Material UI for Backend </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

        </div >
    );
};

export default ProjectsDetails;